<!--  -->
<template>
  <div v-loading="loadingtable">
    <div class="band_box">
      <div>
        <div class="search_box">
          <!-- <el-input v-model="obr.employee_no" placeholder="请输入自有员工编号" style="width:200px" />
          <el-input v-model="obr.name" placeholder="请输入员工姓名" style="width:200px;margin-left:10px" /> -->
          <el-input
            v-model="obr.keywords"
            clearable
            style="width:240px;"
            placeholder="请输入企业id/自有员工编号/员工ID/员工姓名"
          />
          <el-select
            v-model="obr.onlyMe"
            placeholder="请选择"
          >
            <el-option
              v-for="item in accountarr"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
          <el-button
            type="primary"
            class="search_icon"
            icon="el-icon-search"
            @click="secahclkick"
          />
        </div>
        <div class="choses_box">
          <div
            class="select_box"
            :class="[fullName?'choose_blockr':'']"
            @click="whole"
          />
          <div
            v-if="fullName"
            @click="whole"
          >
            取消全选
          </div>
          <div
            v-else
            @click="whole"
          >
            全选
          </div>
        </div>
        <div class="choose_allblock">
          <div
            v-for="item,index in arr"
            :key="index"
            :class="[item.tips?'have ':'']"
            class="choose_block"
          >
            <!-- {{ item.canChecked }} -->
            <div
              v-if="item.can_checked === 9"
              class="select_boxone"
            />
            <div
              v-else
              class="select_box"
              :class="[item.tips?'choose_blockr':'']"
              @click="itenclick(item,index)"
            />
            <span>{{ item.name }}（{{ item.corp_name }}）</span>
          </div>
        </div>

      </div>
      <div class="rigboxr">
        <div style="align-items: center;display: flex">
          <div style="float: left;margin-right: 10px">选中的员工</div>
          <el-button
            size="mini"
            type="primary"
            @click="numberImport = true"
          >快捷导入</el-button>
        </div>
        <el-tag
          v-for="itemr,index in arrs"
          :key="index"
          style="margin-right:10px;margin-bottom:5px"
          closable
          :type="itemr.type"
          @close="rightclick(itemr.employee_no,index,itemr)"
        >
          {{ itemr.name }}（{{ itemr.corp_name }}）
        </el-tag>
      </div>
      <div style="margin-left:20px;border-left: 1px solid #ccc;padding-left: 20px;">
        <div style="display:flex;flex-direction:row;margin-right:10px;">
          <div
            v-if="group_selection == 1 && push_method ==1"
            style="display: flex;align-items: center;"
          >
            <div
              class="choiceofficialaccount"
              style="margin-bottom: 0;margin-right: 10px;"
            >筛选标签组开关</div>
            <el-switch v-model="group_value" />
          </div>
          <div
            v-if="group_selection == 1 && push_method ==1"
            style="display: flex;align-items: center;"
          >
            <div
              class="choiceofficialaccount"
              style="margin-bottom: 0;margin-right: 10px;"
            >无标签客户</div>
            <el-switch
              v-model="state"
              active-value="2"
              inactive-value="1"
            />
          </div>
        </div>
        <el-button
          v-if="group_value === true "
          size="mini"
          type="primary"
          @click="tagGroupImports()"
        >快捷筛选导入</el-button>
        <div
          v-if="group_selection == 1 && push_method ==1"
          style="height: 442px;overflow-y: auto;width: 300px;"
        >
          <div v-show="group_value == true">
            <div style="display: flex;align-items: center;">
              <div
                class="choiceofficialaccount"
                style="margin-top: 10px;margin-right: 10px;"
              >标签组</div>
            </div>
            <el-tree
              ref="tree"
              :data="data"
              show-checkbox
              default-expand-all
              node-key="id"
              highlight-current
              :props="defaultProps"
            />
          </div>
        </div>

      </div>
    </div>
    <div>
      <pagination-right
        style="padding:0;margin-top:20px;justify-content:left"
        :total="total"
        :current-page="obr.page"
        :page-sizes="[50]"
        @size-change="fetchPageSize"
        @current-change="fetchCurrentPage"
      />
    </div>

    <div class="que_box">
      <el-button
        type="primary"
        :loading="sumbitloading"
        @click="quebtn"
      >{{ sumbitloading == true ? '绑定中' : '确定' }}</el-button>
    </div>
    <el-dialog
      title="员工编号导入"
      :visible.sync="numberImport"
      :append-to-body="true"
      width="600px"
      @close="gunwebi"
    >
      <el-input
        v-model="employee_nos"
        type="textarea"
        :rows="3"
        placeholder="请输入员工编号，输入多个请用英文逗号隔开"
        @blur="emblur"
      />
      <div style="margin: 20px 0;" />
      <el-input
        v-model="names"
        type="textarea"
        :rows="3"
        placeholder="请输入员工名称，输入多个请用英文逗号隔开"
        @blur="namesblur"
      />
      <div style="margin: 20px 0;" />
      <div style="display: flex;justify-content: space-between;align-items: center">
        <div style="width: 45px">
          企业名称:
        </div>
        <el-input
          v-model="corp_names"
          type="textarea"
          :rows="2"
          placeholder="请输入企业名称，输入多个请用英文逗号隔开(如不输入,则会导入所有企业下包含当前员工编号和员工名称的员工)"
          @blur="cnsblur"
        />
      </div>
      <div style="margin: 20px 0;" />
      <el-checkbox
        v-if="corp_allids.length!=0"
        v-model="checkAll"
        :indeterminate="isIndeterminate"
        @change="handleCheckAllChange"
      >全选</el-checkbox>
      <div style="margin: 15px 0;" />
      <el-checkbox-group
        v-model="corp_idsow"
        @change="handleCheckedCitiesChange"
      >
        <el-checkbox-button
          v-for="city in corp_allids"
          :key="city.corp_id"
          :label="city.corp_id"
        >{{ city.corp_name }}</el-checkbox-button>
      </el-checkbox-group>
      <div style="margin: 15px 0;" />
      <el-button
        type="primary"
        @click="getEmployees()"
      >提交</el-button>
      <el-button
        type="info"
        @click="gunwebi"
      >取消</el-button>
    </el-dialog>
    <el-dialog
      title="标签组导入"
      :visible.sync="tag_group_import"
      :append-to-body="true"
      width="30%"
    >
      <el-input
        v-model="tag_group_imports"
        type="textarea"
        :rows="3"
        placeholder="请输标签组名称，输入多个请用逗号或者换行隔开"
        @blur="tag_groupsblur"
      />
      <div style="margin: 20px 0;" />
      <div style="margin: 20px 0;" />
      <el-button
        type="primary"
        @click="getTagGroups()"
      >提交</el-button>
      <el-button
        type="info"
        @click="tag_group_import = false"
      >取消</el-button>
    </el-dialog>
    <el-dialog
      title="标签导入"
      :visible.sync="editnumberbool"
      :append-to-body="true"
      :destroy-on-close="true"
      width="30%"
    >
      <editnumber
        ref="editnumberview"
        @callbackanlabel="callbackanlabel"
      />
    </el-dialog>
  </div>
</template>

<script>
import PaginationRight from '@/components/PaginationRight/index.vue'
import convertToHump from '@/utils/mixins/convertToHump.js'
import { sprcorpUsersForStrategy, corpTag, getEmployees } from '@/api/officialaccount.js'
import editnumber from './editnumber.vue'
export default {
  components: {
    PaginationRight,
    editnumber
  },
  mixins: [convertToHump],
  data() {
    return {
      searchvalue: null,
      searchTopicLoading: false, // 搜索锁
      topicList: [], // 公众号临时绑定数组
      options: [], // 公众号列表数组
      value1: [], // 公众号多选完成集合数组
      id: null, // 点击保存的id
      tableData: [], // 表格数组
      arr: [],
      arrs: [],
      arrsw: [],
      obr: {
        employee_no: null,
        name: null,
        sp_strategy_no: null,
        keywords: null,
        page: 1,
        pageSize: 50,
        onlyMe: 2
      },
      accountarr: [
        {
          value: 1,
          label: '查看组内授权员工'
        },
        {
          value: 2,
          label: '我授权的企业员工'
        }
      ],
      total: null,
      sp_strategy_no: null,
      loadingtable: false,
      group_selection: null,
      push_method: null,
      data: [],
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      arrse: [],
      corpidarr: [],
      alltagarr: [],
      chser: null,
      aarwer: [],
      group_value: false,
      state: 1,
      numberImport: false,
      employee_nos: [], // 员工编号集合
      names: [], // 员工名称集
      corp_names: [], // 企业名称集
      editnumberbool: false,
      editnamearr: [],
      bangwearr: [],
      weixuanbzho: [],
      checkedKeys: [], // 用于存储当前选中的节点
      tag_group_import: false,
      tag_group_imports: null,
      confirm: 0,
      corp_allids: [],
      corp_idsow: [],
      isIndeterminate: true,
      checkAll: false,
      sumbitloading: false
    }
  },
  computed: {
    fullName: function() {
      return this.arr
        .filter(num => {
          return num.can_checked !== 9
        })
        .every(function(item) {
          return item.tips === true
        })
    }
  },
  watch: {
    group_value(newValue) {
      if (newValue === true) {
        this.state = 1
      }
    },
    state(newValue) {
      // eslint-disable-next-line eqeqeq
      if (newValue == 2) {
        this.group_value = false
        // this.arrs = []
      }
    }
  },
  created() {},
  mounted() {},
  methods: {
    secahclkick() {
      this.obr.page = 1
      this.list()
    },

    // 点击确定
    async quebtn() {
      // eslint-disable-next-line eqeqeq
      if (this.group_selection == 1 && this.push_method == 1) {
        if (this.arrs.length === 0) {
          this.$message.error('请选择要绑定的员工')
          return
        }
        if (this.$refs.tree.getCheckedNodes().length === 0 && this.group_value) {
          this.$message({
            message: '请选择标签',
            type: 'error'
          })
          return
        }
        this.arrse = this.fnTree(this.data).map(item => {
          return item.id
        })
        this.arrsw = [] // 选中的人员
        this.arrsw = this.arrs.map(item => {
          // item是数组中的每一个值
          return item.employee_no
        })
        const tag_ids = this.$refs.tree.getCheckedKeys(true) // 选中的标签组
        this.$emit('callbacklabel', tag_ids, this.arrsw, this.sp_strategy_no, this.group_value, Number(this.state))
      } else {
        this.arrsw = []
        this.arrsw = this.arrs.map(item => {
          // item是数组中的每一个值
          return item.employee_no
        })
        if (this.arrs.length === 0) {
          this.$message.error('请选择要绑定的员工')
          return
        }
        this.$emit('bandarr', this.arrsw, this.sp_strategy_no, 1)
      }
    },
    itenclick(item, index) {
      item.tips = !item.tips
      if (item.tips) {
        // eslint-disable-next-line eqeqeq
        if (this.group_selection == 1 && this.push_method == 1) {
          this.getlabel(item)
        }
        this.arrs.push({ employee_no: item.employee_no, name: item.name, corp_name: item.corp_name, corp_id: item.corp_id })
        // eslint-disable-next-line eqeqeq
        if (this.group_selection == 1 && this.push_method == 1) {
          if (this.chser === -1) {
            this.gettree()
          }
        }
      } else {
        const index = this.arrs.findIndex(items => {
          return items.employee_no === item.employee_no
        })
        this.arrs.splice(index, 1)
        // eslint-disable-next-line eqeqeq
        if (this.group_selection == 1 && this.push_method == 1) {
          this.getlabeljian(item)
        }
      }
    },
    // 请求标签组的问题 减
    getlabeljian(item) {
      if (this.arrs.length === 0) {
        this.data = []
        return
      }
      const indexr = this.arrs.findIndex(items => {
        return items.corp_id === item.corp_id
      })
      if (indexr === -1) {
        this.gettree()
      }
    },
    // 请求标签组的问题 加
    getlabel(item) {
      // eslint-disable-next-line eqeqeq
      if (this.group_selection == 1 && this.push_method == 1) {
        const indexr = this.arrs.findIndex(items => {
          return items.corp_id === item.corp_id
        })
        if (indexr === -1) {
          this.chser = indexr
          // this.gettree()
        } else {
          this.chser = indexr
        }
      }
    },
    // 获取所有的子集
    fnTree(arr) {
      // 取树状数据的所有子集
      return arr.reduce((prev, cur) => {
        return prev.concat(cur.children && cur.children.length ? this.fnTree(cur.children) : cur)
      }, [])
    },
    // 获取标签
    gettree() {
      this.corpidarr = this.arrs.map(item => {
        return item.corp_id
      })
      corpTag({
        corp_id: this.corpidarr
      }).then(res => {
        this.alltagarr = []
        for (let i = 0; i < res.data.length; i++) {
          this.alltagarr.push({
            id: res.data[i].corp_id,
            label: res.data[i].corp_name
          })
        }
        for (let l = 0; l < this.alltagarr.length; l++) {
          this.alltagarr[l].children = []
        }
        for (let i = 0; i < res.data.length; i++) {
          for (let k = 0; k < res.data[i].children.length; k++) {
            this.alltagarr[i].children.push({
              id: res.data[i].children[k].group_id,
              label: res.data[i].children[k].group_name
            })
          }
        }

        for (let r = 0; r < this.alltagarr.length; r++) {
          for (let x = 0; x < this.alltagarr[r].children.length; x++) {
            this.alltagarr[r].children[x].children = []
          }
        }
        for (let u = 0; u < res.data.length; u++) {
          for (let f = 0; f < res.data[u].children.length; f++) {
            for (let g = 0; g < res.data[u].children[f].children.length; g++) {
              this.alltagarr[u].children[f].children.push({
                id: res.data[u].children[f].children[g].tag_id,
                label: res.data[u].children[f].children[g].tag_name,
                corp_id: res.data[u].children[f].children[g].corp_id
              })
            }
          }
        }
        this.data = this.alltagarr
      })
    },

    whole() {
      if (this.fullName === true) {
        // if (this.arrs.length === this.arr.length) {
        this.arr.forEach(item => {
          if (item.can_checked === 1) {
            item.tips = false
            const index = this.arrs.findIndex(items => {
              return items.employee_no === item.employee_no
            })
            this.arrs.splice(index, 1)
          }
        })
        this.data = []
      } else {
        this.arr.forEach(item => {
          if (item.can_checked === 1) {
            item.tips = true
            this.arrs.map(re => re.employee_no).includes(item.employee_no) || this.arrs.push({ employee_no: item.employee_no, name: item.name, corp_name: item.corp_name, corp_id: item.corp_id })
          }
        })
        // this.arr.forEach((item) => {
        //   this.arrs.includes(item.id) || this.arr.push(item.id)
        // })
        this.gettree()
      }
    },
    rightclick(employee_no, index, itemr) {
      this.arrs.splice(index, 1)
      this.arr.findIndex(items => {
        if (items.employee_no === employee_no) {
          items.tips = false
        }
      })
      // eslint-disable-next-line eqeqeq
      if (this.group_selection == 1 && this.push_method == 1) {
        this.getlabeljian(itemr)
      }
    },
    sendr(id, type, push_method, sp_strategy_type) {
      this.obr.sp_strategy_no = id
      this.sp_strategy_no = id
      this.group_selection = type
      this.push_method = push_method
      if (sp_strategy_type === 4) {
        this.push_method = 1
      }
      this.list()
    },
    async list() {
      this.loadingtable = true
      const data = await sprcorpUsersForStrategy(this.obr)
      this.total = data.data.total
      data.data.list.forEach(item => {
        item.tips = false
      })
      this.arr = data.data.list
      this.arr.forEach(item => {
        this.arrs.forEach(items => {
          if (items.employee_no === item.employee_no) {
            item.tips = true
          }
        })
      })
      this.loadingtable = false
    },
    // 分页
    fetchPageSize(e) {
      this.obr.pageSize = e
      this.list()
    },
    fetchCurrentPage(e) {
      this.obr.page = e
      this.list()
    },
    async getEmployees() {
      if (this.confirm === 1 && this.corp_idsow.length === 0) {
        this.$message({
          message: '请选择要选中的人员的企业',
          type: 'error'
        })
        return
      }
      const data = await getEmployees({
        names: this.names,
        employee_nos: this.employee_nos,
        corp_names: this.corp_names,
        confirm: this.confirm,
        corp_ids: this.corp_idsow
      })
      if (data.code === 201) {
        console.log('201', data.data.corp)
        this.$message({
          message: '您导入的员工存在多企业，请选择后再次点击提交',
          type: 'error'
        })
        this.confirm = 1
        if (data.data.corp.length !== 0) {
          this.corp_allids = []
          this.corp_allids = data.data.corp
          this.corp_idsow = []
          this.corp_idsow = this.corp_allids.map(item => {
            return item.corp_id
          })
          this.isIndeterminate = false
          this.checkAll = true
        }
      } else {
        if (this.arrs.length === 0) {
          this.arrs = data.data.employee
          this.arr.forEach(item => {
            if (data.data.employee != null) {
              const match = data.data.employee.find(d => d.employee_no === item.employee_no)
              if (match) {
                item.tips = true
              }
            }
          })
        } else {
          this.arr.forEach(item => {
            if (data.data.employee != null) {
              const match = data.data.employee.find(d => d.employee_no === item.employee_no)
              if (match) {
                item.tips = true
              }
            }
          })

          if (data.data.employee != null) {
            data.data.employee.forEach(item => {
              const match = this.arrs.find(d => d.employee_no === item.employee_no)
              if (match) {
                console.log('11')
              } else {
                console.log('push')
                this.arrs.push(item)
              }
            })
          }
        }
        console.log('this.arrs', this.arrs)
        // this.arrs = data.data
        this.$message({
          message: '导入成功',
          type: 'success'
        })
        this.numberImport = false
        this.employee_nos = ''
        this.corp_names = []
        this.names = ''
        if (data.data.employee.length !== 0) {
          this.gettree()
        }
      }
    },
    emblur() {
      this.employee_nos = this.employee_nos.replace(/\n/g, ',').replace(/\s+/g, '').replace(/[，]/g, ',')
      console.log('val', this.employee_nos)
    },
    namesblur() {
      this.names = this.names.replace(/\n/g, ',').replace(/\s+/g, '').replace(/[，]/g, ',')
      console.log('val', this.names)
    },
    cnsblur() {
      const corpName = this.corp_names.replace(/\n/g, ',').replace(/\s+/g, '').replace(/[，]/g, ',')
      this.corp_names = corpName ? corpName.split(',') : []
      // this.corp_names = this.corp_names.replace(/\n/g, ',').replace(/\s+/g, '').replace(/[，]/g, ',').split(',')
      // console.log('val', this.corp_names)
    },
    suwerexport() {
      this.editnumberbool = true
    },
    callbackanlabel(anlabel) {
      this.editnumberbool = false
      if (this.editnamearr.length === 0) {
        this.editnamearr = this.findCommonItems(this.fnTreeawe(this.data), anlabel)
      } else {
        this.findCommonItems(this.fnTreeawe(this.data), anlabel).forEach(item => {
          const match = this.editnamearr.find(d => d === item)
          if (match) {
            console.log('11')
          } else {
            console.log('push')
            this.editnamearr.push(item)
          }
        })
      }
      // console.log('this.editnamearr', this.editnamearr)
      // this.bangwearr = []
      // this.bangwearr = this.findCommonItems(this.fnTreeawe(this.data), this.editnamearr)
      // console.log('this.bangwearr', this.bangwearr)
      this.$refs.tree.setCheckedKeys(this.editnamearr)
    },
    // handleCheckChange(node, checked) {
    //   if (!checked) {
    //     // 被取消选中的节点
    //     console.log('被取消选中的节点:', node.label)
    //     const index = this.editnamearr.findIndex(items => {
    //       return items == node.id
    //     })
    //     this.editnamearr.splice(index, 1)
    //     // 更新 checkedKeys 数组
    //     // this.checkedKeys = this.checkedKeys.filter(key => key !== node.id)
    //   } else {
    //     console.log('选中的节点')
    //     // 更新 checkedKeys 数组
    //     // this.checkedKeys.push(node.id)
    //   }
    //   console.log('this.editnamearr', this.editnamearr)
    //   // console.log('当前选中的节点:', this.checkedKeys)
    // },
    handleCheckChange(node, checked) {
      console.log('node', node)
      const nodeId = node.id

      if (!checked) {
        // 如果节点被取消选中，移除该节点ID
        this.editnamearr = this.editnamearr.filter(id => id !== nodeId)
      } else {
        // 如果节点被选中，添加该节点ID
        if (!this.editnamearr.includes(nodeId)) {
          this.editnamearr.push(nodeId)
        }
      }
    },
    fnTreeawe(arr) {
      return arr.reduce((prev, cur) => {
        return prev.concat(cur.children && cur.children.length ? this.fnTreeawe(cur.children) : cur)
      }, [])
    },
    findCommonItems(arr1, arr2) {
      const common = []
      arr1.forEach(item => {
        if (arr2.includes(item.label)) {
          common.push(item.id)
        }
      })
      return common
    },
    tag_groupsblur() {
      this.tag_group_imports = this.tag_group_imports.replace(/[\n，]/g, ',')
    },
    getTagGroups() {
      var old_checkedKeys = this.$refs.tree.getCheckedKeys(true)
      const checkedYes = []
      const inputArray = this.tag_group_imports.split(',').map(item => item.trim())
      this.recursiveSelect(this.data, inputArray, checkedYes)
      const allCheckedIds = [...new Set([...old_checkedKeys, ...checkedYes])]
      this.$refs.tree.setCheckedKeys(allCheckedIds)
      this.tag_group_import = false
    },
    tagGroupImports() {
      if (this.data.length === 0 || this.group_value === false) {
        this.$message({
          message: '请先选择左侧员工并且打开筛选标签组开关',
          type: 'error'
        })
        return
      }
      this.tag_group_import = true
    },
    recursiveSelect(nodes, values, checkedYes = []) {
      nodes.forEach(node => {
        if (values.includes(node.label)) {
          this.collectNodeKeys(node, checkedYes)
          checkedYes.push(node.id)
        }
        if (node.children && Array.isArray(node.children) && node.children.length > 0) {
          this.recursiveSelect(node.children, values, checkedYes)
        }
      })
    },
    collectNodeKeys(node, checkedKeys) {
      if (node.children && Array.isArray(node.children) && node.children.length > 0) {
        node.children.forEach(child => {
          this.collectNodeKeys(child, checkedKeys)
        })
      }
    },
    handleCheckAllChange(val) {
      console.log(val)
      if (val === true) {
        console.log('true')
        this.corp_idsow = []
        this.corp_idsow = this.corp_allids.map(item => {
          return item.corp_id
        })
      } else {
        this.corp_idsow = []
        console.log('false')
      }
      this.isIndeterminate = false
    },
    handleCheckedCitiesChange(value) {
      console.log('value', value, this.corp_idsow.length)
      const checkedCount = value.length
      this.checkAll = checkedCount === this.corp_allids.length
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.corp_allids.length
    },
    gunwebi() {
      console.log('关闭')
      this.numberImport = false
      this.confirm = 0
      this.corp_allids = []
      this.corp_idsow = []
      this.isIndeterminate = false
      this.checkAll = false
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.allbox {
  padding: 30px;
}
.que_box {
  margin-top: 20px;
}
.have {
  color: #409eff;
}
.serch_box {
  display: flex;

  margin-bottom: 10px;
}
.search_icon {
  margin-left: 10px;
}
.band_box {
  display: flex;
}
.choses_box {
  margin-bottom: 10px;
  display: flex;
  align-items: center;
}
.select_box {
  height: 14px;
  width: 14px;
  border-radius: 3px;
  border: 1px solid skyblue;
  margin-right: 7px;
}
.select_boxone {
  height: 14px;
  width: 14px;
  border-radius: 3px;
  border: 1px solid #ccc;
  margin-right: 7px;
  background-color: #ccc;
}
.choose_block {
  display: flex;
  align-items: center;
  margin-bottom: 5px;
  margin-right: 10px;
}
.choose_blockr {
  background: #409eff;
}
.rigboxr {
  /* margin-left: 85px; */
  border-left: 1px solid #ccc;
  padding-left: 30px;
  max-height: 450px;
  overflow-y: scroll;
  width: 350px;
  /* overflow: hidden;
  overflow-y: scroll; */
}
/* :-webkit-scrollbar {
     height: 0 !important;
} */
/* ::-webkit-scrollbar {
     width: 0 !important;height: 0;
  } */
.choiceofficialaccount {
  margin-bottom: 10px;
}
.select_spacing {
  margin-bottom: 5px;
}
.choose_allblock {
  height: 370px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  overflow-x: scroll;
  /* min-width: 600px; */
}
.el-tree /deep/ .el-tree__empty-block {
  width: 130px;
}
</style>
